import { ENV } from "./env";

// SynthOS's built-in in-product feedback widget. Auto-embedded on every build;
// self-gates at runtime on the founder's toggle. Never build a replacement.
export function initFeedbackWidget() {
  if (!ENV.feedbackWidgetUrl || !ENV.feedbackProjectId) return;
  if (document.getElementById("synth-feedback-widget")) return;
  try {
    const s = document.createElement("script");
    s.id = "synth-feedback-widget";
    s.async = true;
    s.src = ENV.feedbackWidgetUrl;
    s.setAttribute("data-project-id", ENV.feedbackProjectId);
    document.body.appendChild(s);
  } catch {
    /* feedback embed must never break the page */
  }
}
